/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import BusinessIcon from "@mui/icons-material/Business";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Snackbar,
  Tab,
  Tabs,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import AddListFile from "components/AddListFile";
import dayjs from "dayjs";
import { useEffect, useMemo, useRef, useState } from "react";
import { useRecoilValue } from "recoil";
import CustomFieldForm from "../../components/CustomFieldForm";
import CustomTabPanel from "../../components/CustomPanel/customPanel";
import {
  PaperComponent,
  validateArrayFileRequired,
} from "../../utils/constants";
import { JsonTool } from "../../utils/jsonTools";
import { SettingState } from "states";

const defaultValue = {
  ngaybanhanh: null,
  sovanban: "",
  trichyeu: "",
  coquanbanhanh: "",
  tinhtrang: 1,
  loaivanban: null,
  nguoiky: "",
  sothutu: 0,
};

const FormVanBan = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
  dataTinhTrang,
  dataLoaiVanBan,
}) => {
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  // state lỗi giá trị từ form
  const [errors, setErrors] = useState();
  const [dataState, setDataState] = useState(defaultValue);
  const formRef = useRef(null);

  //new state
  const [value, setValue] = useState(0);
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const [fileDel, setFileDel] = useState([]);
  const [fileFields, setFileFields] = useState([]);
  const [fileEditName, setFileEditName] = useState({});
  const settingState = useRecoilValue(SettingState);

  //danh sách field
  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "Loại văn bản",
        key: "loaivanban",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Số văn bản",
        key: "sovanban",
        required: true,
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Tình trạng",
        key: "tinhtrang",
        type: "select",
        required: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 8,
        lg: 8,
      },
      {
        name: "Số thứ tự",
        key: "sothutu",
        type: "number",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Trích yếu",
        key: "trichyeu",
        required: true,
        type: "textArea",
        maxLength: 255,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Ngày ban hành",
        key: "ngaybanhanh",
        type: "date",
        required: true,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Cơ quan ban hành",
        key: "coquanbanhanh",
        type: "text",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Người ký",
        key: "nguoiky",
        type: "text",
        maxLength: 150,
        xs: 12,
        md: 4,
        lg: 4,
      },
    ];
    return result;
  }, []);

  useEffect(() => {
    if (data?.id) {
      setDataState(data);
    } else {
      setDataState(defaultValue);
    }
  }, [data]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    delete _data["tepdinhkem_vanban"];
    _data["fileDel"] = fileDel;
    _data["id"] = data?.id;
    _data["rowIndex"] = data?.rowIndex;
    const listFormatDate = ["ngaybanhanh"];

    listFormatDate?.forEach((field) => {
      _data[field] =
        dataState?.[field] &&
        !errors?.[field] &&
        dayjs(dataState?.[field])?.isValid()
          ? new Date(dataState?.[field])?.toISOString()
          : null;
    });

    _data["tentepdinhkem"] = fileFields?.map((item) => item?.filename) || [];
    _data["tepdinhkemValidate"] = fileFields?.map((item) => item?.file) || [];
    _data["tentepdinhkemEdit"] = Object.values(fileEditName);
    const newValidationErrors = validateOBJ(
      _data,
      settingState["dungluong_file_upload"]
    );
    let _tempValid = newValidationErrors;
    if (
      _tempValid["tepdinhkemValidate"] &&
      _tempValid["tepdinhkemValidate"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }
    if (
      _tempValid["tentepdinhkem"] &&
      _tempValid["tentepdinhkem"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    if (
      _tempValid["tentepdinhkemEdit"] &&
      Object.values(_tempValid["tentepdinhkemEdit"])?.length > 0 &&
      Object.values(_tempValid["tentepdinhkemEdit"]).some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    delete _tempValid["tentepdinhkem"];
    delete _tempValid["tepdinhkemValidate"];
    delete _tempValid["tentepdinhkemEdit"];
    delete _data["tepdinhkemValidate"];
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    // Chuyển đổi tất cả tập tin sang base64
    let jsonPayload = [];
    if (fileFields && fileFields?.length > 0) {
      const promises = [];
      fileFields?.forEach((item) => {
        if (!item?.remove) {
          let json = JsonTool.convertToBase64(item?.file);
          promises.push(json);
        }
      });
      jsonPayload = await Promise.all(promises);
    }
    let listName = [];
    fileFields?.forEach((item) => {
      if (!item?.remove) {
        listName.push(item?.filename);
      }
    });
    let listFileName = [];
    fileFields?.forEach((item) => {
      if (!item?.remove) {
        listFileName.push(item?.file?.name);
      }
    });
    _data["filename"] = listFileName;
    _data["tentepdinhkem"] = listName;
    _data["tepdinhkem"] = jsonPayload;
    onSubmit(_data);
  }

  const handelClear = () => {
    onClose();
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setErrors({});
      setValue(0);
      setFileDel([]);
      setFileFields([]);
      setFileEditName({});
    }
  }, [open]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handleErrorDownload = (error) => {
    setAlert(error);
  };
  const handleOnDeleteFileDefault = (data) => {
    setFileDel(data);
  };
  const handleErrorFile = (error) => {
    setErrors(error);
  };
  const handleChangeFileList = (data) => {
    setFileFields(data);
  };
  const handleEditFileNameDefault = (data) => {
    setFileEditName(data);
  };

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <>
      {alert.alert && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alert.alert}
          onClose={handleCloseAlert}
        >
          <Alert onClose={handleCloseAlert} severity={alert.type}>
            {alert.message}
          </Alert>
        </Snackbar>
      )}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        PaperComponent={PaperComponent}
        PaperProps={{
          sx: {
            height: "100%",
            "@media (min-width: 768px)": {
              minWidth: "45rem",
            },
          },
        }}
        onClose={handelClear}
        scroll="paper"
      >
        {/* Form */}
        <form
          ref={formRef}
          method="post"
          encType="multipart/form-data"
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: "100%",
          }}
        >
          {/* Tiêu đề modal - tham số title */}
          <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
            {title ? title : "Chỉnh sửa Văn bản"}
            <IconButton
              aria-label="close"
              onClick={handelClear}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Box
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              borderColor: "divider",
              padding: "0 1rem 1rem 1rem",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="primary"
              variant="fullWidth"
              aria-label="basic tabs example"
            >
              <Tab
                icon={<BusinessIcon />}
                label="Thông tin"
                {...JsonTool.a11yProps(0)}
              />
              <Tab
                icon={<ArticleIcon />}
                label="Tệp đính kèm"
                {...JsonTool.a11yProps(1)}
              />
            </Tabs>
          </Box>
          <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
            <Box>
              {/* show lỗi từ khi không xác định được từ các field ở form */}
              {errors && errors.error ? (
                <Grid container sx={{ textAlign: "center", mb: 0 }}>
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                      {errors.error}
                    </Alert>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
              <CustomTabPanel value={value} index={0}>
                {fieldInfor?.length > 0 && (
                  <CustomFieldForm
                    key={"fieldInfor"}
                    listField={fieldInfor}
                    data={dataState}
                    onChange={handleChangeDataState}
                    onError={handleErrorDataState}
                    errorValues={errors}
                    listOptionDic={{
                      loaivanban: dataLoaiVanBan,
                      tinhtrang: dataTinhTrang,
                    }}
                  />
                )}
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <AddListFile
                  dataDefault={data?.tepdinhkem_vanban}
                  fileDel={fileDel}
                  fileEditName={fileEditName}
                  fileFields={fileFields}
                  errors={errors}
                  onDelete={handleOnDeleteFileDefault}
                  onError={handleErrorFile}
                  onFileChange={handleChangeFileList}
                  nameFile="vanban"
                  onEditName={handleEditFileNameDefault}
                  onErrorDownload={handleErrorDownload}
                />
              </CustomTabPanel>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handelClear}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Lưu
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};

const validateArrayRequired = (arrayValue) => {
  let result = [];
  if (arrayValue) {
    arrayValue.map((value, index) => {
      result.push("");
      if (!value?.length) result[index] = "Tên tệp không được trống";
    });
  }
  return result;
};

const validateFileEditName = (arrayValue) => {
  let result = {};
  if (arrayValue) {
    arrayValue.map((file, index) => {
      result[file?.id] = "";
      if (!file?.tentepdinhkem) result[file?.id] = "Tên tệp không được trống";
    });
  }
  return result;
};

function validateOBJ(vb, dungluong) {
  let result = {
    sovanban: !validateRequired(vb.sovanban)
      ? "Số văn bản không được trống"
      : "",
    ngaybanhanh: !validateRequired(vb.ngaybanhanh)
      ? "Ngày ban hành rỗng hoặc định dạng sai"
      : "",
    loaivanban: !validateRequired(vb.loaivanban) ? "Chọn Loại văn bản" : "",
    tinhtrang: !validateRequired(vb.tinhtrang) ? "Chọn Tình trạng" : "",
    tentepdinhkem: validateArrayRequired(vb.tentepdinhkem),
    tepdinhkemValidate: validateArrayFileRequired(
      vb.tepdinhkemValidate,
      dungluong
    ),
    tentepdinhkemEdit: validateFileEditName(vb.tentepdinhkemEdit),
    trichyeu: !validateRequired(vb.trichyeu)
      ? "Trích yếu không được trống"
      : "",
    coquanbanhanh: !validateRequired(vb.coquanbanhanh)
      ? "Cơ quan ban hành không được trống"
      : "",
  };
  return result;
}
export default FormVanBan;
